
import { defineComponent, ref } from "vue";
import Permission from "@/core/config/Permission";
import Datatable from "@/components/kt-datatable/KTDatatable.vue";
import axios from "@/axios-instance"
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { hideModal } from "@/core/helpers/dom";

interface ICustomer {
    id: string;
    name: string;
    fee: number;
}
interface IPagination {
    currentPage: number;
    total: number;
    limit: number;
}
interface IData {
    id: string;
    name: string;
    fee: number;
}
export default defineComponent({
    name: "Combination-code",
    components: {
        Datatable,
    },
    data() {
        return {
        }
    },
    methods: {
        callModalAddApp(e) {
            e.preventDefault()
            this.isEdit = false
            this.kt_modal_add_combination?.click()
            this.resetDataForm()
        },
        resetDataForm() {
            if (!this.formRef) return
            this.formRef.resetFields()
            let temp = {
                "id": '',
                "name": "",
                "fee": 0,
            }
            this.formData = temp
        },
        deleteRow(record) {
            Swal.fire({
                text: `Bạn có muốn xóa phí khác này không?`,
                icon: "question",
                buttonsStyling: false,
                showCancelButton: true,
                confirmButtonText: "Đồng ý",
                cancelButtonText: "Trở lại",
                customClass: {
                    confirmButton: "btn btn-primary order-2",
                    cancelButton: "btn btn-light order-1",
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    let index = this.tableData.findIndex(item => item.id == record.id)
                    this.tableData.splice(index, 1);
                    axios.delete(`/setting/fee/other/${record.id}`)
                }
                Swal.close()
            });
        },
        async setDataForm(record) {
            this.resetDataForm()
            this.idFormEdit = record.id
            await axios.get(`/setting/fee/other/${record.id}`)
                .then(({ data }) => {
                    this.formData = {...data, fee: parseInt(data.fee)}
                    this.isEdit = true
                    this.kt_modal_add_combination?.click()
                })
                .catch(({ response }) => {
                    console.log('err', response)
                });
        }
    },

    async mounted() {
        await axios.get(`/setting/fee/other`)
            .then(({ data }) => {
                data.forEach(item => {
                    let temp = {
                        id: item.id,
                        name: item.name,
                        fee: parseInt(item.fee)
                    }
                    this.tableData.push(temp)
                })
            })
            .catch(({ response }) => {
                console.log('err', response)
            });
    },
    setup() {
        const kt_modal_add_combination = ref<null | HTMLElement>(null);
        const addCombinationModalRef = ref<null | HTMLElement>(null);
        const isEdit = ref(false);
        const idFormEdit = ref('');

        const pagination = ref<IPagination>({
            currentPage: 1,
            total: 0,
            limit: 1000,
        });
        const tableHeader = ref([
            {
                name: "Tên phí khác",
                key: "name",
                sortable: true,
            },
            {
                name: "Giá trị phí",
                key: "fee",
                sortable: true,
            },
            {
                name: "HÀNH ĐỘNG",
                key: "actions",
                sortable: false,
                class: "text-center"
            },
        ]);
        const formData = ref<IData>({ "id": '', "name": "", "fee": 0 })
        const tableData = ref<Array<ICustomer>>([]);
        const arrMajors = ref([]) as any;
        const formRef = ref<HTMLFormElement | null>(null);
        const checkNumber = (rule: any, value: any, callback: any) => {
            if (!value) {
                return callback(new Error('Vui lòng điền trường này'))
            }
            setTimeout(() => {
                if (!Number.isInteger(value)) {
                    callback(new Error('Vui lòng nhập các chữ số'))
                } else {
                    callback()
                }
            }, 1000)
        }
        const rules = ref({
            name: {
                required: true,
                message: "Vui lòng điền trường này",
                trigger: "change"
            },
            fee: [{ validator: checkNumber, trigger: 'blur' }],
        })
        const submit = () => {
            if (!formRef.value) { return; }
            formRef.value.validate(async (valid) => {
                if (valid) {
                    let method = isEdit.value ? 'put' : 'post'
                    let id = isEdit.value ? `/${idFormEdit.value}` : ''
                    let data = {
                        "name": formData.value.name != "" ? formData.value.name : undefined,
                        "fee": formData.value.fee != 0 ? formData.value.fee : undefined
                    }
                    await axios[method](`/setting/fee/other${id}`, data)
                        .then(({ data }) => {
                            let temp = {
                                id: data.item.id,
                                name: data.item.name,
                                fee: parseInt(data.item.fee),
                            }
                            if (!isEdit.value) {
                                tableData.value.push(temp)
                            }
                            else {
                                let index = tableData.value.findIndex(item => item.id == data.item.id)
                                if (index >= 0) {
                                    tableData.value[index] = temp
                                }
                            }
                            hideModal(addCombinationModalRef.value);
                        })
                        .catch(({ response }) => {
                            console.log('err', response)
                        });

                } else {
                    return false;
                }
            });
        };
        return {
            kt_modal_add_combination,
            formRef,
            rules,
            addCombinationModalRef,
            pagination,
            tableHeader,
            tableData,
            Permission,
            arrMajors,
            submit,
            formData,
            isEdit,
            idFormEdit,
        };
    },
});
